import { DateTime } from 'luxon';
import { Typography } from '@la/ds-ui-components';
import { Activity } from '@la/types';
import { getLAHostnameParts } from '@la/utilities';
import { isGameActivity } from 'lib/utils/schedules/isGameActivity';
import { useGetTeamQuery } from 'redux/services/teamApi';
import {
  ProgramPermissions,
  UserSummary,
} from 'redux/services/types/singleActivity';
import GameScore from '../SingleActivityViewGameScore/GameScore';
import { activityTypes } from '../utils/singleActivityView.utils';
import styles from './SingleActivityViewDetails.module.scss';

export default function SingleActivityViewDetails({
  activity,
  userSummaries,
  permissions,
}: {
  activity?: Activity;
  userSummaries: UserSummary[];
  permissions?: ProgramPermissions;
}) {
  const { subdomain } = getLAHostnameParts();

  const isGame = isGameActivity(activity?.type);
  const activityType = isGame ? 'Game' : 'Event';

  const teamId = userSummaries[0]?.teamIds?.[0];

  const { data: team } = useGetTeamQuery(
    {
      siteDomain: subdomain,
      teamId: teamId ? teamId.toString() : '0',
    },
    { skip: !teamId }
  );

  let activityTitle = activity?.title;
  if (!activityTitle && activity && team) {
    activityTitle =
      activity?.title ?? `${team.name} ${activityTypes[activity.type]}`;
  }

  const activityDateDetails = activity?.start
    ? DateTime.fromISO(activity.start.date).toFormat('EEEE, LLL d, yyyy')
    : 'TBD';

  const activityStartTimeDetails = activity?.start?.time
    ? DateTime.fromISO(activity.start.time).toFormat('t')
    : 'TBD';

  const activityEndTimeDetails = activity?.end?.time
    ? DateTime.fromISO(activity.end.time).toFormat('t')
    : 'TBD';

  return (
    <>
      <div className={styles.detailsContainer}>
        <Typography variant="ui" size="large" weight="bold">
          {activityType}
        </Typography>
      </div>

      {isGame ? (
        <GameScore activity={activity} permissions={permissions} />
      ) : (
        <Typography
          variant="headline"
          size="medium"
          className={styles.paddingContainer}
        >
          {activityTitle}
        </Typography>
      )}
      <div className={styles.paddingContainer}>
        <Typography variant="ui" size="medium">
          {activityDateDetails}
        </Typography>
        <Typography variant="ui" size="medium">
          {activityStartTimeDetails} to {activityEndTimeDetails}
        </Typography>
      </div>
    </>
  );
}
